import { Calendar } from "lucide-react";

import EHRCard from "@/src/components/cards/ehr-cards/ehr-card";
import { formatHumanReadableDate } from "@/src/lib/utils/date-and-phone-utils";
import { Appointment } from "@/src/models/appointment";

interface EHRAppointmentRemindersCardProps {
  appointmentReminders: Appointment[];
}

export default function EHRAppointmentRemindersCard({ appointmentReminders }: EHRAppointmentRemindersCardProps) {
  return (
    <EHRCard icon={<Calendar />} title="Appointment Reminders">
      {appointmentReminders.length === 0 && (
        <p className="text-sm text-muted-foreground">No appointment reminders available</p>
      )}

      {appointmentReminders.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left font-medium py-2">Date</th>
                <th className="text-left font-medium py-2">Type</th>
                <th className="text-left font-medium py-2">Status</th>
                <th className="text-left font-medium py-2">Created</th>
                <th className="text-left font-medium py-2">Notes</th>
              </tr>
            </thead>
            <tbody>
              {appointmentReminders.map((appointment) => (
                <tr key={appointment.id} className="border-b border-border/50">
                  <td className="py-2">
                    {appointment.appointmentDatetime ? formatHumanReadableDate(appointment.appointmentDatetime) : "TBD"}
                  </td>
                  <td className="py-2">{appointment.ehrType || appointment.type || "N/A"}</td>
                  <td className="py-2">{appointment.ehrStatus || appointment.status || "N/A"}</td>
                  <td className="py-2">
                    {appointment.appointmentCreatedAt
                      ? formatHumanReadableDate(appointment.appointmentCreatedAt)
                      : "N/A"}
                  </td>
                  <td className="py-2 max-w-xs truncate" title={appointment.ehrReason || ""}>
                    {appointment.ehrReason || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </EHRCard>
  );
}
